import React from 'react';
import classnames from 'classnames';
import { Paragraph, SmallUppercase } from 'scy/text';
import { emptyState } from './list.mod.scss';
import margin from 'scy/margin.mod.scss';

export default function EmptyState({ className }) {
  return (
    <div className={classnames(emptyState, className)}>
      <blockquote>
        <Paragraph>
          “The problem with the world is that everyone is a few drinks behind.”
        </Paragraph>
        <SmallUppercase tag="footer" marginClass={margin.sm}>
          - Humphrey Bogart
        </SmallUppercase>
      </blockquote>
    </div>
  );
}
